import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Box, useTheme } from '@mui/material';
import { WizardUtils } from '../../../../../utils/WizardUtils';

export const CriteriaFormulaPreview = ({ conditionTree }) => {
  const theme = useTheme();
  const formulaString = useMemo(() => WizardUtils.createTriggerConditionStringFromTree(conditionTree), [conditionTree]);

  const formattedFormula = useMemo(() => {
    if (!formulaString) return null;
    // Split by AND and OR while keeping the delimiters
    const parts = formulaString.split(/(\bAND\b|\bOR\b)/g);
    return parts.map((part, index) => {
      if (part === 'AND' || part === 'OR') {
        return (
          <span key={index} style={{ fontWeight: 'bold', color: theme.palette.text.primary }}>
            {part}
          </span>
        );
      }
      return <span key={index}>{part}</span>;
    });
  }, [formulaString, theme.palette.text.primary]);

  return (
    <Box
      data-cy="criteria-formula-preview-textfield"
      sx={{
        width: '100%',
        padding: 1.5,
        border: '1px solid',
        borderColor: 'grey.400',
        borderRadius: 1,
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
        fontSize: '1.1rem',
      }}
    >
      {formattedFormula}
    </Box>
  );
};

CriteriaFormulaPreview.propTypes = {
  conditionTree: PropTypes.object,
};

CriteriaFormulaPreview.defaultProps = {
  conditionTree: {},
};
